import React from 'react'
import { flexRender } from '@tanstack/react-table'
import styled from 'styled-components'

import {
    TABLE_WIDTH_NUMBER_MODIFIER,
    TABLE_WIDTH_PERCENTAGE_MODIFIER,
} from '../..'
import { TableFooter } from '../TableFooter'
import { TableRow } from '../TableRow'

const TableFootElement = styled.tfoot``

const getColumnWidth = (size) => {
    if (size >= TABLE_WIDTH_PERCENTAGE_MODIFIER) {
        return `${size / TABLE_WIDTH_PERCENTAGE_MODIFIER}%`
    }

    if (size >= TABLE_WIDTH_NUMBER_MODIFIER) {
        return `${size / TABLE_WIDTH_NUMBER_MODIFIER}`
    }

    return null
}

export const TableFoot = ({
  table,
  getRowProps = () => {},
  getColumnProps = () => {},
  getCellProps = () => {},
  getFooterProps = () => {},
}) => (
    <TableFootElement className="table-foot">
        {table.getFooterGroups().map((footerGroup, i) => (
            <TableRow key={`${footerGroup.id}_${i}`}>
                {footerGroup.headers.map((footer, i) => {
                    if (footer.column.columnDef.footer === undefined) {
                        return null
                    }

                    return (
                        <TableFooter
                            key={`${footer.id}_${i}`}
                            colSpan={footer.colSpan}
                            width={`${getColumnWidth(footer.getSize())}px`}
                            type={typeof table.getRowModel().rows[0]?.original[footer.id]}
                            getColumnProps={() =>
                                getColumnProps(footer.column.id, footer.column)
                            }
                            getRowProps={() => getRowProps(footerGroup)}
                            getFooterProps={() => getFooterProps(footer)}
                            getCellProps={() => getCellProps(footer)}
                        >
                            {flexRender(footer.column.columnDef.footer, footer.getContext())}
                        </TableFooter>
                    )
                })}
            </TableRow>
        ))}
    </TableFootElement>
)